import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SEO } from '../../shared/SEO';

import financerCampageImg2 from "../../assets/appImage/financerCampageImg2.png";
import financerCampageImg3 from "../../assets/appImage/financerCampageImg3.png";
import financerCampageImg4 from "../../assets/appImage/financerCampageImg4.png";
import { useProjetsOnlineQuery } from '../../../utils/api/launchCampagn/projet.api';
import { useGetCategorieQuery } from "../../../utils/api/categorie/categorie.api";
import { Categorie } from "../../../utils/api/categorie/categorie.type";
import { useProductsByFilterQuery } from '../../../utils/api/produit/produit.api';
import { useAvisByVisitorQuery } from '../../../utils/api/avis/avis.api';
import ConfigApi from '../../../utils/api/config/config.api';
import { formatAmout, getImage } from '../../../utils/utils';
import moment from 'moment';
import { getRoutePath } from '../../routes/routes';
import FrontHeader from '../../shared/FrontHeader/FrontHeader';
import BtnAjouterAuPanier from '../shop/MarketPlace/Common/BtnAjouterAuPanier';
import FrontFooter from '../../shared/FrontFooter/FrontFooter';
import Pagination from "../../shared/Pagination";
import { createMarkup, videoIdFromUrl } from '../../../utils/utils'
// import Frame from "../../assets/appImage/Frame.png";
// import 'react-loading-skeleton/dist/skeleton.css';

import './HomePage.css';
import { Group } from 'lucide-react';

const HomePage = () => {
  const [search, setSearch] = useState("");
  const { data: categories = [] } = useGetCategorieQuery();
  const [category, setCategory] = useState(0);
  const [page, setPage] = useState(1);
  const { data: projetsData = { results: [], count: 0 }, isLoading } = useProjetsOnlineQuery({
    page,
    category_id: category !== 0 ? category : undefined,
    name__icontains: search,
    statut: "online",
  });

  useEffect(() => {
    setPage(1);
  }, [category, search]);

  const { data: products = { results: [] } } = useProductsByFilterQuery({});
  const { data: avis = { results: [] } } = useAvisByVisitorQuery({});
  const { data: config } = ConfigApi.useGetConfigQuery();

  const projects = projetsData.results;
  const featuredProject = projects.length > 0 ? projects[0] : null;
  const featuredCategoryName = (featuredProject as any)?.category?.name || (featuredProject as any)?.category_name || (featuredProject as any)?.categorie?.name || "Humanitaire · Communautés";
  const listProjects = projects.length > 1 ? projects.slice(1, 4) : [];

  const marketProducts = products.results.slice(0, 5);
  const testimonials = avis.results.slice(0, 3);

  const [hearts, setHearts] = useState<{ [key: string]: boolean }>({});
  const toggleHeart = (id: string) => {
    setHearts(prev => ({ ...prev, [id]: !prev[id] }));
  };

  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          if (e.target.classList.contains('featured') || e.target.classList.contains('camp')) {
            const bars = e.target.querySelectorAll('.progress > i, .camp-bar > i');
            bars.forEach(bar => {
              const b = bar as HTMLElement;
              const w = b.getAttribute('data-w');
              if (w) requestAnimationFrame(() => { b.style.width = w; });
            });
          }
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.reveal').forEach(el => io.observe(el));

    // Ticker animation
    const track = document.getElementById('ticker-track');
    if (track) {
      let idx = 0;
      const items = track.children.length - 1;
      const interval = setInterval(() => {
        idx++;
        track.style.transform = `translateY(-${idx * 18}px)`;
        if (idx >= items) {
          setTimeout(() => {
            track.style.transition = 'none';
            track.style.transform = 'translateY(0)';
            idx = 0;
            requestAnimationFrame(() => { track.style.transition = ''; });
          }, 600);
        }
      }, 2800);
      return () => clearInterval(interval);
    }
  }, [projects, marketProducts, testimonials]);

  const fr = (n: number) => n.toLocaleString('fr-FR').replace(/,/g, ' ');

  const WUY_MAJJAL_DATA = [
    {
      title: config?.title_why_one,
      image: Group,
      description: createMarkup(config?.description_why_one),
      index: 1,
    },
    {
      title: config?.title_why_two,
      image: Group,
      description: createMarkup(config?.description_why_two),
      index: 2,
    },
    {
      title: config?.title_why_three,
      image: Group,
      description: createMarkup(config?.description_why_three),
      index: 3,
    },
  ]

  return (
    <div className="home-page-container">
      <SEO />

      <FrontHeader />

      <section className="hero" style={{ marginTop: 0, paddingTop: '18px' }}>
        <div className="hero-inner">
          <div>
            {/* <h1> Réunissons nos <em>moyens</em>, réalisons grand.</h1> */}
            <h1
                  className="titre-banniere"
                  dangerouslySetInnerHTML={createMarkup(config?.slogan)}
                />
          </div>

          <div className="hero-visual">
            <div className="hv-card hv-main">
              <div className="hv-img">
                <Link to={getRoutePath("CampainsDetails", { slug: featuredProject?.slug })}>
                  <div className="feat-cover">

                    {featuredProject?.photo ? (
                      <img src={getImage(featuredProject.photo)} alt="Cover" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '16px' }} />
                    ) : (
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4"></path></svg>
                    )}
                    <div className="glyph">m</div>
                  </div>
                </Link>
              </div>
              <h4>{featuredProject?.name || "Projet en vedette"}</h4>
              <div className="sub">{featuredCategoryName}</div>
              <div className="progress"><i style={{ width: `${featuredProject?.pourcentage || 0}%` }} data-w={`${featuredProject?.pourcentage || 0}%`}></i></div>
              <div className="prog-meta">
                <div className="raised"><small>{formatAmout(featuredProject?.objectif_levee || 0)}</small></div>
                <div className="pct">{Math.ceil(featuredProject?.pourcentage || 0)}%</div>
              </div>
            </div>
            <div className="hv-card hv-pay">
              <div className="hv-pay-h">Moyens de paiement</div>
              <div className="hv-pay-row">
                <div className="hv-pay-ic pay-w"><img
                  src={financerCampageImg2}
                  className="card-img-financer-campagne"
                  style={{ marginTop: 0 }}
                  alt="img campagne"
                /></div>
                <div className="nm">Wave</div>
              </div>
              <div className="hv-pay-row">
                <div className="hv-pay-ic pay-o"><img
                  src={financerCampageImg3}
                  className="card-img-financer-campagne"
                  style={{ marginTop: 0 }}
                  alt="img campagne"
                /></div>
                <div className="nm">Orange Money</div>
              </div>
              <div className="hv-pay-row">
                <div className="hv-pay-ic pay-c"><img
                  src={financerCampageImg4}
                  className="card-img-financer-campagne"
                  style={{ marginTop: 0 }}
                  alt="img campagne"
                /></div>
                <div className="nm">Carte bancaire</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="sect-inner">
          <div className="sect-head"><h2>Actions rapides</h2></div>
          <div className="quick">
            <Link to="/app/lancer-une-campagne" className="qa">
              <div className="qa-icon qa-1"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14"></path></svg></div>
              <span className="lbl">Lancer<br />une cagnotte</span>
            </Link>
            <Link to="/app/campagnes" className="qa">
              <div className="qa-icon qa-2"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg></div>
              <span className="lbl">Contribuer<br />à un projet</span>
            </Link>
            <Link to="/app/marketplace" className="qa">
              <div className="qa-icon qa-3"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"></path></svg></div>
              <span className="lbl">Marketplace</span>
            </Link>
            <Link to="/app/tableau-de-bord/mes-projets" className="qa">
              <div className="qa-icon qa-4"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M8 12h8M12 8v8"></path></svg></div>
              <span className="lbl">Mes<br />cagnottes</span>
            </Link>
          </div>
        </div>
      </section>

      <section id="campaigns">
        <div className="sect-inner">
          <div className="sect-head">
            <h2>Campagnes</h2>
            <Link className="more" to="/app/campagnes">Tout voir
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6"></path></svg>
            </Link>
          </div>

          <div className="filters" id="campFilters">
            <button
              className={`chip ${category === 0 ? 'on' : ''}`}
              onClick={() => setCategory(0)}
            >
              Toutes <span className="ct">{projetsData.count}</span>
            </button>
            {categories.map((cat: Categorie) => (
              <button
                key={cat.id}
                className={`chip ${category === cat.id ? 'on' : ''}`}
                onClick={() => setCategory(cat.id)}
              >
                {cat.name}
              </button>
            ))}
          </div>

          <div className="two-col">
            {featuredProject && (
              <article className="featured reveal">
                <Link to={getRoutePath("CampainsDetails", { slug: featuredProject.slug })}>
                  <div className="feat-cover">

                    {featuredProject.photo ? (
                      <img src={getImage(featuredProject.photo)} alt="Cover" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '16px' }} />
                    ) : (
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18M5 21V7l8-4v18M19 21V11l-6-4"></path></svg>
                    )}
                    <div className="feat-badges">
                      <span className="feat-tag"><span className="liv"></span>À la une · En cours</span>
                      <span className="feat-time">{Math.max(0, moment(featuredProject.date_fin).diff(moment(), "days"))} jours</span>
                    </div>
                    <div className="glyph">m</div>
                  </div>
                </Link>

                <div className="feat-body">
                  <div className="feat-cat">{featuredCategoryName || "Humanitaire"}</div>
                  <Link to={getRoutePath("CampainsDetails", { slug: featuredProject.slug })}>
                    <div className="feat-title" style={{ color: 'inherit' }}>{featuredProject.name}</div>
                  </Link>
                  <div className="progress"><i style={{ width: `${featuredProject.pourcentage}%` }} data-w={`${featuredProject.pourcentage}%`}></i></div>
                  <div className="prog-meta">
                    <div className="raised"><small> {formatAmout(featuredProject.objectif_levee)}</small></div>
                    <div className="pct">{Math.ceil(featuredProject.pourcentage)}%</div>
                  </div>
                  <div className="feat-foot">
                    <div className="avs">
                      <div className="av-1"></div>
                      <div className="av-2"></div>
                      <div className="av-3"></div>
                    </div>
                    <div className="ct"><b>{featuredProject.nb_investisseur} bailleurs</b></div>
                    <Link className="feat-cta" to={getRoutePath("CampainsDetails", { slug: featuredProject.slug })}>
                      Contribuer
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7"></path></svg>
                    </Link>
                  </div>
                </div>
              </article>
            )}

            <div className="camp-list">
              {isLoading && <p>Chargement des campagnes...</p>}
              {!isLoading && listProjects.map((p: any, i: number) => {
                const thumbs = ['thumb-a', 'thumb-b', 'thumb-c', 'thumb-d'];
                const emojis = ['🌅', '🤲', '🕌', '🎓'];
                return (
                  <Link to={getRoutePath("CampainsDetails", { slug: p.slug })} key={p.id} style={{ color: 'inherit' }}>
                    <article className="camp">
                      <div className={`camp-thumb ${thumbs[i % thumbs.length]}`}>
                        {p.photo ? (
                          <img src={getImage(p.photo)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          emojis[i % emojis.length]
                        )}
                      </div>
                      <div className="camp-body">
                        <div className="camp-cat">{p.category?.name || "Catégorie"}</div>
                        <div className="camp-title">{p.name}</div>
                        <div className="camp-bar"><i style={{ width: `${p.pourcentage}%` }} data-w={`${p.pourcentage}%`}></i></div>
                        <div className="camp-meta">
                          <span className="pct">{Math.ceil(p.pourcentage)}% · {p.nb_investisseur} bailleurs</span>
                          <span className="am">/ {formatAmout(p.objectif_levee)}</span>
                        </div>
                      </div>
                    </article>
                  </Link>
                );
              })}
            </div>
          </div>
          {(projetsData?.count ?? 0) > 0 && (
            <div style={{ marginTop: '20px' }}>
              <Pagination page={page} onPageChange={setPage} total={projetsData.count} />
            </div>
          )}
        </div>
      </section>

      <section>
        <div className="sect-inner">
          <div className="why-block reveal">
            <span className="why-eyebrow">Pourquoi maajjal</span>
            <h3>Pensé pour <em>votre communauté</em>.</h3>

            <div className="why-items">
              {WUY_MAJJAL_DATA.map((item) => (
                <div className="why-it" key={item.index || item.title}>
                  {/* Conteneur de bloc pour forcer le texte à prendre sa largeur normale */}
                  <div className="why-text-content" style={{ width: '100%', minWidth: '0' }}>
                    <h4>{item.title || "Titre par défaut"}</h4>
                    <p dangerouslySetInnerHTML={item.description} />
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      <section id="market">
        <div className="sect-inner">
          <div className="sect-head">
            <h2>Marketplace</h2>
            <Link className="more" to="/app/marketplace">Tout voir
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6"></path></svg>
            </Link>
          </div>
          <div className="h-scroll">
            {marketProducts.map((prod: any, idx: number) => {
              const bgClasses = ['p-1', 'p-2', 'p-3', 'p-4', 'p-5'];
              const emojis = ['🛒', '🌿', '🍯', '☕', '📿'];
              return (
                <article className="prod" key={prod.id}>
                  <Link to={getRoutePath("ProductMarketDetail", { slug: prod.slug })} style={{ color: 'inherit' }}>
                    <div className={`prod-img ${bgClasses[idx % bgClasses.length]}`}>
                      {prod.discount ? <span className="prod-disc">-{prod.discount}%</span> : null}
                      <span className={`prod-heart ${hearts[prod.id] ? 'liked' : ''}`} onClick={(e) => { e.preventDefault(); toggleHeart(prod.id.toString()); }}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill={hearts[prod.id] ? "currentColor" : "none"} stroke="currentColor" strokeWidth={hearts[prod.id] ? "0" : "2"} strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                      </span>
                      {prod.avatar ? (
                        <img src={getImage(prod.avatar)} alt={prod.name} className="prod-image" />
                      ) : (
                        <span>{emojis[idx % emojis.length]}</span>
                      )}
                    </div>
                    <div className="prod-body">
                      <div className="prod-name">{prod.name}</div>
                      <div className="prod-price">{formatAmout(prod.price_discount || prod.prix)} {prod.price_discount && <small>{formatAmout(prod.prix)}</small>}</div>
                    </div>
                  </Link>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section>
        <div className="sect-inner">
          <div className="how reveal">
            <span className="why-eyebrow">Comment ça marche</span>
            <h3>Quatre étapes, <em>zéro complication</em>.</h3>
            <div className="how-steps">
              <div className="step">
                <div className="step-n">01</div>
                <div>
                  <h4>Créez votre cagnotte</h4>
                  <p>Décrivez votre projet, fixez l'objectif en quelques minutes.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-n">02</div>
                <div>
                  <h4>Mobilisez votre réseau</h4>
                  <p>Partagez sur WhatsApp, Facebook ou par lien.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-n">03</div>
                <div>
                  <h4>Recevez en transparence</h4>
                  <p>Wave, Orange Money, CB, chaque don est tracé.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-n">04</div>
                <div>
                  <h4>Concrétisez votre projet</h4>
                  <p>Retirez vos fonds, rendez compte à vos bailleurs.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="sect-inner">
          <div className="pay-cta">
            <div className="pays reveal">
              <h3>Paiements acceptés</h3>
              <p className="s">Sécurisé, instantané, sans frais cachés.</p>
              <div className="pay-grid">
                <div className="pay"><div className="pay-ic pay-w"><img
                  src={financerCampageImg2}
                  className="card-img-financer-campagne"
                  style={{ marginTop: 0 }}
                  alt="img campagne"
                /></div><div className="pay-l">Wave</div></div>
                <div className="pay"><div className="pay-ic pay-o"><img
                  src={financerCampageImg3}
                  className="card-img-financer-campagne"
                  style={{ marginTop: 0 }}
                  alt="img campagne"
                /></div><div className="pay-l">Orange Money</div></div>
                <div className="pay"><div className="pay-ic pay-c"><img
                  src={financerCampageImg4}
                  className="card-img-financer-campagne"
                  style={{ marginTop: 0 }}
                  alt="img campagne"
                /></div><div className="pay-l">Carte bancaire</div></div>
              </div>
            </div>
            {/* <div className="cta-band reveal">
              <h3>Votre projet mérite <em>d'aboutir</em>.</h3>
              <p>Plus de 2 000 porteurs et bailleurs transforment leurs idées en réalité avec Maajjal.</p>
              <div className="btn-row">
                <Link className="btn-primary" to="/app/lancer-une-campagne">
                  Lancer ma cagnotte
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7"></path></svg>
                </Link>
                <Link className="btn-ghost" to="/app/campagnes">Découvrir</Link>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* <section>
        <div className="sect-inner">
          <div className="sect-head"><h2>Ils nous font confiance</h2></div>
          <div className="testi-grid">
            <div className="testi reveal">
              <p>Lever 2,5 millions de F CFA en moins d'un mois sans Maajjal c'était impensable. La transparence rassure nos bailleurs.</p>
              <div className="testi-aut">
                <div className="testi-av"></div>
                <div>
                  <div className="nm">Ibrahim Diop</div>
                  <div className="rl">Porteur · A&C Values</div>
                </div>
              </div>
            </div>
            <div className="testi reveal">
              <p>Interface claire, paiement en deux clics avec Wave. J'ai contribué à trois projets ce mois-ci sans hésiter.</p>
              <div className="testi-aut">
                <div className="testi-av" style={{ background: 'linear-gradient(135deg,#86efac,var(--green-deep))' }}></div>
                <div>
                  <div className="nm">Aïssatou Ndiaye</div>
                  <div className="rl">Bailleuse régulière</div>
                </div>
              </div>
            </div>
            <div className="testi reveal">
              <p>La marketplace en plus du financement, c'est l'idée géniale. Mes produits trouvent leur public chaque semaine.</p>
              <div className="testi-aut">
                <div className="testi-av" style={{ background: 'linear-gradient(135deg,#a5b4fc,#4338ca)' }}></div>
                <div>
                  <div className="nm">Moussa Fall</div>
                  <div className="rl">Vendeur · Café Touba</div>
                </div>
              </div>
            </div>
          </div>
          <div className="testi-pager">
            <span className="d on"></span><span className="d"></span><span className="d"></span>
          </div>
        </div>
      </section> */}

      <FrontFooter />

    </div>
  );
};

export default HomePage;
